/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { Instance } from "mobx-state-tree"
import { SmsAddonSubscribedDtoModelBase } from "./SmsAddonSubscribedDtoModel.base"

/* The TypeScript type of an instance of SmsAddonSubscribedDtoModel */
export interface SmsAddonSubscribedDtoModelType extends Instance<typeof SmsAddonSubscribedDtoModel.Type> {}

/* A graphql query fragment builders for SmsAddonSubscribedDtoModel */
export { selectFromSmsAddonSubscribedDto, smsAddonSubscribedDtoModelPrimitives, SmsAddonSubscribedDtoModelSelector } from "./SmsAddonSubscribedDtoModel.base"

/**
 * SmsAddonSubscribedDtoModel
 */
export const SmsAddonSubscribedDtoModel = SmsAddonSubscribedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
